export default class YmlGeneratorResponse {
    process_id = ''
    is_completed = false
    summary = new YmlGeneratorResponseSummary()
    is_invalid = true
    request_key = 0
    profile_document = null
    error_message = ''

    is_lost = false

    constructor(response_data) {
        if (response_data.hasOwnProperty('ready')) {
            this.is_invalid = false
            this.is_lost = true
            this.is_completed = true
        } else if (response_data) {
            this.error_message = response_data.error_message

            if (response_data.is_invalid === false) {
                this.process_id = response_data.process_id
                this.is_completed = response_data.is_completed
                this.summary = new YmlGeneratorResponseSummary(response_data.summary)
                this.request_key = parseInt(response_data.request_key)
                this.is_invalid = false
                this.profile_document = response_data.profile_document
            }
        }
    }
}

class YmlGeneratorResponseSummary {
    is_completed = false
    percent = 0
    exported_offers_count = 0
    current_state_description = ''

    constructor(summary) {
        if (summary) {
            this.is_completed = summary.is_completed
            this.percent = summary.percent
            this.exported_offers_count = summary.exported_offers_count
            this.current_state_description = summary.current_state_description
        }
    }
}